const LoadingSpinner = () => <porsche-p-spinner size="small" />;

export default LoadingSpinner;
